import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id, PagedParams, PagedResponse, getQueryKey, invalidateAfterDelete } from '@/feature/utils';

import * as api from './CommitteeApi';
import { Committee, CommitteeRequest } from './CommitteeTypes';

const committeeKey = getQueryKey('committee');

export function getCommitteePagedOptions(params: PagedParams): UseSuspenseQueryOptions<PagedResponse<Committee>> {
  return {
    queryKey: committeeKey.paged(params),
    queryFn: () => api.getPaged(params),
  };
}

export function getCommitteeOptions(committeeId: Id): UseSuspenseQueryOptions<Committee> {
  return {
    queryKey: committeeKey.one(committeeId),
    queryFn: () => api.get(committeeId),
  };
}

export function useCommitteeEdit(committeeId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CommitteeRequest) => api.edit(committeeId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: committeeKey.root(),
      }),
  });
}

export function useCommitteeCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CommitteeRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: committeeKey.root(),
      }),
  });
}

export function useCommitteeDelete(committeeId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(committeeId),
    onSuccess: () => invalidateAfterDelete(queryClient, committeeKey, committeeId),
  });
}
